import { render, staticRenderFns } from "./LinkedDiscounts.vue?vue&type=template&id=03e2dbb2&scoped=true&"
import script from "./LinkedDiscounts.vue?vue&type=script&lang=js&"
export * from "./LinkedDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./LinkedDiscounts.vue?vue&type=style&index=0&id=03e2dbb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2dbb2",
  null
  
)

export default component.exports